import { lib } from '@gocanvas/client'
const { LABELS_ABOVE_SHEET_TYPE_ID, LABELS_LEFT_SHEET_TYPE_ID } = lib

export const orderByPosition = (first, second) =>
  first.position - second.position

// ensures we're not counting "undefined" === "undefined" as a match
// isTrueStringMatch (Any, Any) -> Boolean
export const isTrueStringMatch = (str1, str2) =>
  str1 != null &&
  str1 !== '' &&
  str2 != null &&
  str2 !== '' &&
  `${str1}` === `${str2}`

export const isStandardScreen = ({ sheet_type_id }) => {
  return [LABELS_ABOVE_SHEET_TYPE_ID, LABELS_LEFT_SHEET_TYPE_ID].includes(
    sheet_type_id
  )
}

export const whiteListedTypesForPaymentField = ['Sum', 'Calculation', 'Number']

export const paymentDataToIncludeBlacklist = [
  'Photo',
  'Static Image',
  'Signature',
  'Drawing',
  'Payment',
  'Checkbox',
]

export const checkNumberStyleForPaymentTotalField = ({ type, style }) => {
  if (type === 'Number') {
    if (style === 0 || style === 4) {
      return true
    } else {
      return false
    }
  }
  return true
}

// used on eligibleDependentEntries to filter out entries but also sheets
// with no entries
// example
// sheetsWithEntries.reduce(createDependentEntriesFilterFn(entry => entry.visible), ({ label, id })=>{ label, value: id })
export const createDependentEntriesFilterFn = (filterFn, mapFn = x => x) => (sheets, sheet) => {
  const filteredEntries = sheet.entries.reduce((entries, entry) => {
    if (filterFn(entry)) {
      entries.push(mapFn(entry))
    }
    return entries
  }, [])

  // Only include the sheet if it has entries after filtering
  if (filteredEntries.length > 0) {
    sheets.push({
      ...sheet,
      entries: filteredEntries
    })
  }

  return sheets
}

export const setIntersection = (setA, setB) => {
  if (setA.intersection) {
    return setA.intersection(setB)
  }
  
  const result = new Set()
  for (const item of setA) {
    if (setB.has(item)) {
      result.add(item);
    }
  }
  return result
}

// updates position of all items if their position was above a removed item
// not passing a sheetId means it will run on all items, otherwise it runs only
// on items with a match sheetID
// reIndexOnDelete :: Array -> Array
export const reIndexOnDelete = (entries, oldPosition, sheetId) =>
  entries.map(entry => {
    if (!sheetId || isTrueStringMatch(entry.sheet_id, sheetId)) {
      const position =
        oldPosition < entry.position ? entry.position - 1 : entry.position
      return {
        ...entry,
        position,
      }
    } else {
      return entry
    }
  })
